export const radarCloudsData = [
  {
    legendTypeIconName: "radarCloudsRainIcon",
    title: "Rain",
    src: require("../../images/radarCloudsRain.png"),
  },
  {
    legendTypeIconName: "radarCloudsMixIcon",
    title: "Mixed",
    src: require("../../images/radarCloudsSleet.png"),
  },
  {
    legendTypeIconName: "radarCloudsSnowIcon",
    title: "Snow",
    src: require("../../images/radarCloudsSnow.png"),
  },
  {
    legendTypeIconName: "radarCloudsCloudsIcon",
    title: "Clouds",
    src: require("../../images/radarCloudsClouds.png"),
  },
];
export const drivingDifficultyData = [
  {
    legendTypeIconName: "drivingDifficultyIceIcon",
    title: "Ice",
    src: require("../../images/drivingDifficultyIce.png"),
  },
  {
    legendTypeIconName: "drivingDifficultySnowIcon",
    title: "Snow",
    src: require("../../images/drivingDifficultySnow.png"),
  },
  {
    legendTypeIconName: "drivingDifficultyPondingIcon",
    title: "Ponding",
    src: require("../../images/drivingDifficultyPondin.png"),
  },
  {
    legendTypeIconName: "drivingDifficultyWetIcon",
    title: "Wet",
    src: require("../../images/drivingDifficultyWet.png"),
  },
  {
    legendTypeIconName: "drivingDifficultyFogIcon",
    title: "Fog",
    src: require("../../images/drivingDifficultyFog.png"),
  },
  {
    legendTypeIconName: "drivingDifficultyWindIcon",
    title: "Wind",
    src: require("../../images/drivingDifficultyWind.png"),
  },
];
export const weatherAlertData = [
  {
    legendTypeIconName: "legend-type-flood",
    title: "Flood",
    src: require("../../images/weatherAlertFlood.png"),
  },
  {
    legendTypeIconName: "legend-type-other",
    title: "Other",
    src: require("../../images/weatherAlertOther.png"),
  },
  {
    legendTypeIconName: "legend-type-Tropical",
    title: "Tropical",
    src: require("../../images/weatherAlertTropical.png"),
  },
  {
    legendTypeIconName: "legend-type-winter",
    title: "Winter",
    src: require("../../images/weatherAlertWinter.png"),
  },
  {
    legendTypeIconName: "legend-type-tornado",
    title: "Tornado/Severe Storms",
    src: require("../../images/weatherAlertTornado.png"),
  },
];
export const radarSnowColorData = [
  { in: [0, 0.1], out: "rgba(231, 239, 245, 0.7)" },
  { in: [0.1, 1], out: "rgba(195, 215, 230, 0.7)" },
  { in: [1, 2], out: "rgba(123, 175, 211, 0.7)" },
  { in: [2, 3], out: "rgba(69, 129, 184, 0.7)" },
  { in: [3, 4], out: "rgba(36, 80, 152, 0.7)" },
  { in: [4, 6], out: "rgba(15, 41, 144, 0.7)" },
  { in: [6, 8], out: "rgba(253, 250, 163, 0.7)" },
  { in: [8, 12], out: "rgba(241, 199, 95, 0.7)" },
  { in: [12, 18], out: "rgba(228, 140, 76, 0.7)" },
  { in: [18, 24], out: "rgba(204, 67, 57, 0.7)" },
  { in: [24, 30], out: "rgba(148, 46, 38, 0.7)" },
  { in: [30, 36], out: "rgba(98, 28, 22, 0.7)" },
  { in: [36, 48], out: "rgba(46, 8, 6, 0.7)" },
  { in: [48, 60], out: "rgba(206, 205, 247, 0.7)" },
  { in: [60, 72], out: "rgba(157, 143, 212, 0.7)" },
  { in: [72, 96], out: "rgba(120, 84, 161, 0.7)" },
  { in: [96, 120], out: "rgba(80, 37, 111, 0.7)" },
  { in: [120], out: "rgba(38, 13, 46, 0.7)" },
];
export const radarRainColorData = [
  { in: [0, 10], out: "rgba(139, 71, 38, 0.7)" },
  { in: [10, 20], out: "rgba(205, 134, 52, 0.7)" },
  { in: [20, 30], out: "rgba(206, 47, 43, 0.7)" },
  { in: [30, 40], out: "rgba(237, 65, 51, 0.7)" },
  { in: [40, 50], out: "rgba(241, 126, 58, 0.7)" },
  { in: [50, 60], out: "rgba(252, 216, 74, 0.7)" },
  { in: [60, 70], out: "rgba(19, 78, 139, 0.7)" },
  { in: [70, 80], out: "rgba(63, 140, 33, 0.7)" },
  { in: [80, 90], out: "rgba(96, 206, 52, 0.7)" },
  { in: [90], out: "rgba(121, 244, 64, 0.7)" },
];
export const radarSleetColorData = [
  { in: [0, 3], out: "rgba(240, 200, 215, 1)" },
  { in: [3, 5], out: "rgba(234, 187, 219, 1)" },
  { in: [5, 7.5], out: "rgba(242, 158, 199, 0.7)" },
  { in: [7.5, 10], out: "rgba(232, 123, 190, 0.7)" },
  { in: [10, 12.5], out: "rgba(223, 106, 181, 0.7)" },
  { in: [12.5, 15], out: "rgba(209, 76, 163, 0.7)" },
  { in: [15, 17.5], out: "rgba(195, 58, 146, 0.7)" },
  { in: [17.5, 20], out: "rgba(180, 54, 140, 0.7)" },
  { in: [20, 22.5], out: "rgba(163, 47, 119, 0.7)" },
  { in: [22.5, 25], out: "rgba(127, 33, 82, 0.7)" },
  { in: [25, 30], out: "rgba(101, 23, 57, 0.7)" },
  { in: [30], out: "rgba(64, 13, 48, 0.7)" },
];
export const cloudsColorData = [
  { in: [0, 10], out: "rgba(75, 75, 75, 0.7)" },
  { in: [10, 20], out: "rgba(90, 90, 90, 0.7)" },
  { in: [20, 30], out: "rgba(118, 118, 118, 0.7)" },
  { in: [30, 40], out: "rgba(141, 141, 141, 0.7)" },
  { in: [40, 50], out: "rgba(173, 173, 173, 0.7)" },
  { in: [50, 60], out: "rgba(186, 186, 186, 0.7)" },
  { in: [60, 70], out: "rgba(207, 207, 207, 0.7)" },
  { in: [70, 80], out: "rgba(219, 219, 219, 0.7)" },
  { in: [80, 90], out: "rgba(235, 235, 235, 0.7)" },
  { in: [90, 100], out: "rgba(255, 255, 255, 0.7)" },
];
export const drivingDifficultyIceColorData = [
  { in: [0, 3], out: "rgba(239, 179, 246, 0.7)" },
  { in: [3, 5], out: "rgba(235, 172, 241, 0.7)" },
  { in: [5, 7.5], out: "rgba(230, 165, 236, 0.7)" },
  { in: [7, 5, 10], out: "rgba(225, 159, 232, 0.7)" },
  { in: [10, 12.5], out: "rgba(220, 152, 227, 0.7)" },
  { in: [12.5, 15], out: "rgba(216, 146, 223, 0.7)" },
  { in: [15, 17.5], out: "rgba(211, 139, 218, 0.7)" },
  { in: [17.5, 20], out: "rgba(206, 133, 214, 0.7)" },
  { in: [20, 22.5], out: "rgba(202, 126, 209, 0.7)" },
  { in: [22.5, 25], out: "rgba(197, 120, 205, 0.7)" },
  { in: [25, 30], out: "rgba(192, 113, 200, 0.7)" },
  { in: [30], out: "rgba(186, 104, 194, 0.7)" },
];
export const drivingDifficultySnowColorData = [
  { in: [0, 0.1], out: "rgba(224, 224, 225, 0.7)" },
  { in: [0.1, 1], out: "rgba(218, 218, 219, 0.7)" },
  { in: [1, 2], out: "rgba(213, 213, 214, 0.7)" },
  { in: [2, 3], out: "rgba(209, 209, 210, 0.7)" },
  { in: [3, 4], out: "rgba(204, 204, 205, 0.7)" },
  { in: [4, 6], out: "rgba(199, 199, 200, 0.7)" },
  { in: [6, 8], out: "rgba(194, 194, 194, 0.7)" },
  { in: [8, 12], out: "rgba(189, 189, 190, 0.7)" },
  { in: [12, 18], out: "rgba(184, 184, 185, 0.7)" },
  { in: [18, 24], out: "rgba(179, 179, 180, 0.7)" },
  { in: [24, 30], out: "rgba(175, 175, 175, 0.7)" },
  { in: [30, 36], out: "rgba(170, 170, 170, 0.7)" },
  { in: [36, 48], out: "rgba(165, 165, 165, 0.7)" },
  { in: [48, 60], out: "rgba(160, 160, 160, 0.7)" },
  { in: [60, 72], out: "rgba(155, 155, 155, 0.7)" },
  { in: [72, 96], out: "rgba(150, 150, 150, 0.7)" },
  { in: [96, 120], out: "rgba(144, 144, 144, 0.7)" },
  { in: [120], out: "rgba(141, 141, 141, 0.7)" },
];
export const drivingDifficultyPondingColorData = [
  { in: [0, 0.01], out: "rgba(255, 255, 255, 1)" },
  { in: [0.01, 0.1], out: "rgba(127, 255, 0, 0.7)" },
  { in: [0.1, 0.25], out: "rgba(0, 205, 0, 0.7)" },
  { in: [0.25, 0.5], out: "rgba(0, 139, 0, 0.7)" },
  { in: [0.5, 0.75], out: "rgba(16, 78, 139, 0.7)" },
  { in: [0.75, 1], out: "rgba(30, 144, 255, 0.7)" },
  { in: [1, 1.25], out: "rgba(0, 178, 238, 0.7)" },
  { in: [1.25, 1.5], out: "rgba(0, 238, 238, 0.7)" },
  { in: [1.5, 1.75], out: "rgba(137, 104, 205, 0.7)" },
  { in: [1.75, 2], out: "rgba(145, 44, 238, 0.7)" },
  { in: [2, 2.5], out: "rgba(139, 0, 139, 0.7)" },
  { in: [2.5, 3], out: "rgba(139, 0, 0, 0.7)" },
  { in: [3, 4], out: "rgba(205, 0, 0, 0.7)" },
  { in: [4, 5], out: "rgba(238, 64, 0, 0.7)" },
  { in: [5, 7], out: "rgba(255, 127, 0, 0.7)" },
  { in: [7, 10], out: "rgba(205, 133, 0, 0.7)" },
  { in: [10, 15], out: "rgba(255, 215, 0, 0.7)" },
  { in: [15, 20], out: "rgba(255, 255, 0, 0.7)" },
  { in: [20], out: "rgba(255, 174, 185, 0.7)" },
];
export const drivingDifficultyWetColorData = [
  { in: [0, 10], out: "rgba(163, 202, 112, 0.7)" },
  { in: [10, 20], out: "rgba(158, 196, 107, 0.7)" },
  { in: [20, 30], out: "rgba(151, 189, 102, 0.7)" },
  { in: [30, 40], out: "rgba(145, 183, 96, 0.7)" },
  { in: [40, 50], out: "rgba(139, 177, 91, 0.7)" },
  { in: [50, 60], out: "rgba(133, 170, 86, 0.7)" },
  { in: [60, 70], out: "rgba(127, 164, 80, 0.7)" },
  { in: [70, 80], out: "rgba(121, 157, 75, 0.7)" },
  { in: [80, 90], out: "rgba(114, 150, 69, 0.7)" },
  { in: [90], out: "rgba(108, 144, 64, 0.7)" },
];
export const drivingDifficultyFogColorData = [
  { in: [0, 0.06], out: "rgba(156, 127, 45, 0.7)" },
  { in: [0.06, 0.3], out: "rgba(169, 139, 54, 0.7)" },
  { in: [0.3, 0.6], out: "rgba(181, 149, 59, 0.7)" },
  { in: [0.6, 1.2], out: "rgba(201, 168, 73, 0.7)" },
  { in: [1.2, 1.8], out: "rgba(220, 187, 91, 0.7)" },
  { in: [1.8, 3.1], out: "rgba(233, 201, 108, 0.7)" },
  { in: [3.1, 6.2], out: "rgba(240, 218, 155, 0.7)" },
  { in: [6.2, 12], out: "rgba(250, 239, 208, 0.7)" },
  { in: [12], out: "rgba(255, 255, 255, 1)" },
];
export const drivingDifficultyWindColorData = [
  { in: [0, 6], out: "rgba(229, 228, 89, 0.7)" },
  { in: [6, 13], out: "rgba(222, 221, 86, 0.7)" },
  { in: [13, 20], out: "rgba(216, 215, 84, 0.7)" },
  { in: [20, 28], out: "rgba(209, 208, 81, 0.7)" },
  { in: [28, 35], out: "rgba(203, 202, 78, 0.7)" },
  { in: [35, 43], out: "rgba(196, 195, 75, 0.7)" },
  { in: [43, 50], out: "rgba(190, 189, 73, 0.7)" },
  { in: [50, 57], out: "rgba(183, 182, 70, 0.7)" },
  { in: [57, 65], out: "rgba(177, 176, 67, 0.7)" },
  { in: [65, 72], out: "rgba(171, 170, 65, 0.7)" },
  { in: [72, 80], out: "rgba(164, 163, 62, 0.7)" },
  { in: [80, 87], out: "rgba(158, 157, 59, 0.7)" },
  { in: [87, 94], out: "rgba(151, 150, 56, 0.7)" },
  { in: [94, 98], out: "rgba(145, 144, 54, 0.7)" },
  { in: [98], out: "rgba(138, 137, 46, 0.7)" },
];
export const weatherAlertColorData = [
  {
    color: "#C0C0C0",
    title: "911 Telephone Outage Emergency",
  },
  {
    color: "#C0C0C0",
    title: "Administrative Message",
  },
  {
    color: "#C0C0C0",
    title: "Air Quality Alert",
  },
  {
    color: "#808080",
    title: "Air Stagnation Advisory",
  },
  {
    color: "#5EC933",
    title: "Arroyo And Small Stream Flood Advisory",
  },
  {
    color: "#7C47ED",
    title: "Ashfall Advisory",
  },
  {
    color: "#439322",
    title: "Ashfall Warning",
  },
  {
    color: "#2B91F6",
    title: "Avalanche Warning",
  },
  {
    color: "#3D9BF9",
    title: "Avalanche Advisory",
  },
  {
    color: "#F0A25C",
    title: "Avalanche Watch",
  },
  {
    color: "#6DFBFB",
    title: "Beach Hazards Statement",
  },
  {
    color: "#ED4333",
    title: "Blizzard Warning",
  },
  {
    color: "#AAF545",
    title: "Blizzard Watch",
  },
  {
    color: "#BDB76D",
    title: "Blowing Dust Advisory",
  },
  {
    color: "#ED3833",
    title: "Blowing Dust Warning",
  },
  {
    color: "#D7BFD7",
    title: "Brisk Wind Advisory",
  },
  {
    color: "#FCD84A",
    title: "Child Abduction Emergency",
  },
  {
    color: "#F5B6C1",
    title: "Civil Danger Warning",
  },
  {
    color: "#C0C0C0",
    title: "Civil Emergency Message",
  },
  {
    color: "#ECBC3F",
    title: "Coastal Flood Advisory",
    borderColor: "#B18718",
  },
  {
    color: "#6B8E25",
    title: "Coastal Flood Statement",
  },
  {
    color: "#3F8B24",
    title: "Coastal Flood Warning",
  },
  {
    color: "#66CDAA",
    title: "Coastal Flood Watch",
  },
  {
    color: "#738495",
    title: "Dense Fog Advisory",
  },
  {
    color: "#EEEA7E",
    title: "Dense Smoke Advisory",
  },
  {
    color: "#EE7639",
    title: "Dust Advisory",
  },
  {
    color: "#FCE4C3",
    title: "Dust Storm Warning",
  },
  {
    color: "#8B461D",
    title: "Earthquake Warning",
  },
  {
    color: "#79F440",
    title: "Evacuation - Immediate",
  },
  {
    color: "#C83986",
    title: "Excessive Heat Warning",
  },
  {
    color: "#811A17",
    title: "Excessive Heat Watch",
  },
  {
    color: "#298AE8",
    title: "Extreme Cold Warning",
  },
  {
    color: "#58BDF9",
    title: "Extreme Cold Watch",
  },
  {
    color: "#EC67F7",
    title: "Extreme Fire Danger",
  },
  {
    color: "#B761C4",
    title: "Extreme Wind Warning",
  },
  {
    color: "#A0522D",
    title: "Fire Warning",
  },
  {
    color: "#FBDEAD",
    title: "Fire Weather Watch",
  },
  {
    color: "#9ACD3A",
    title: "Flash Flood Statement",
  },
  {
    color: "#8C1D19",
    title: "Flash Flood Warning",
  },
  {
    color: "#60CD34",
    title: "Flash Flood Watch",
  },
  {
    color: "#FF9417",
    title: "Flood Advisory",
    borderColor: "#DD7904",
  },
  {
    color: "#73F33F",
    title: "Flood Statement",
  },
  {
    color: "#73F440",
    title: "Flood Warning",
    borderColor: "#3CA911",
  },
  {
    color: "#3D8C58",
    title: "Flood Watch",
    borderColor: "#1F6436",
  },
  {
    color: "#6DFBFB",
    title: "Freeze Warning",
    borderColor: "#099696",
  },
  {
    color: "#4169E1",
    title: "Freeze Watch",
  },
  {
    color: "#2F7575",
    title: "Freezing Fog Advisory",
  },
  {
    color: "#EB58F9",
    title: "Freezing Rain Advisory",
  },
  {
    color: "#44B0EA",
    title: "Freezing Spray Advisory",
  },
  {
    color: "#5082BA",
    title: "Frost Advisory",
  },
  {
    color: "#DCA1DC",
    title: "Gale Warning",
  },
  {
    color: "#F6C1C9",
    title: "Gale Watch",
  },
  {
    color: "#2046F6",
    title: "Hard Freeze Warning",
  },
  {
    color: "#4169E1",
    title: "Hard Freeze Watch",
  },
  {
    color: "#4D2482",
    title: "Hazardous Materials Warning",
  },
  {
    color: "#DCA1DA",
    title: "Hazardous Seas Warning",
  },
  {
    color: "#483D8C",
    title: "Hazardous Seas Watch",
  },
  {
    color: "#F1EAA9",
    title: "Hazardous Weather Outlook",
  },
  {
    color: "#F17E4E",
    title: "Heat Advisory",
  },
  {
    color: "#4BBFF8",
    title: "Heavy Freezing Spray Warning",
  },
  {
    color: "#B58F94",
    title: "Heavy Freezing Spray Watch",
  },
  {
    color: "#BA55D3",
    title: "High Surf Advisory",
  },
  {
    color: "#3F8B24",
    title: "High Surf Warning",
  },
  {
    color: "#DAA53B",
    title: "High Wind Warning",
  },
  {
    color: "#B98730",
    title: "High Wind Watch",
  },
  {
    color: "#D05B5C",
    title: "Hurricane Force Wind Warning",
  },
  {
    color: "#9932CC",
    title: "Hurricane Force Wind Watch",
  },
  {
    color: "#FEF851",
    title: "Hurricane Local Statement",
  },
  {
    color: "#DD343D",
    title: "Hurricane Warning",
  },
  {
    color: "#E054ED",
    title: "Hurricane Watch",
  },
  {
    color: "#72F57F",
    title: "Hydrologic Advisory",
  },
  {
    color: "#EEBAAA",
    title: "Hydrologic Outlook",
    borderColor: "#B1573B",
  },
  {
    color: "#7C1F88",
    title: "Ice Storm Warning",
  },
  {
    color: "#E0BDDE",
    title: "Lake Effect Snow Advisory",
  },
  {
    color: "#018A8C",
    title: "Lake Effect Snow Warning",
  },
  {
    color: "#89CEFA",
    title: "Lake Effect Snow Watch",
  },
  {
    color: "#BB97EA",
    title: "Lake Wind Advisory",
    borderColor: "#522888",
  },
  {
    color: "#B3E6E2",
    title: "Lakeshore Flood Advisory",
  },
  {
    color: "#71C69B",
    title: "Lakeshore Flood Statement",
  },
  {
    color: "#5CB086",
    title: "Lakeshore Flood Warning",
  },
  {
    color: "#418F68",
    title: "Lakeshore Flood Watch",
  },
  {
    color: "#C0C0C0",
    title: "Law Enforcement Warning",
  },
  {
    color: "#C0C0C0",
    title: "Local Area Emergency",
  },
  {
    color: "#A94959",
    title: "Low Water Advisory",
  },
  {
    color: "#FADAB8",
    title: "Marine Weather Statement",
  },
  {
    color: "#4D2482",
    title: "Nuclear Power Plant Warning",
  },
  {
    color: "#4D2482",
    title: "Radiological Hazard Warning",
  },
  {
    color: "#EC4395",
    title: "Red Flag Warning",
  },
  {
    color: "#63E1CF",
    title: "Rip Current Statement",
    borderColor: "#188B7B",
  },
  {
    color: "#F5A540",
    title: "Severe Thunderstorm Warning",
  },
  {
    color: "#DC7093",
    title: "Severe Thunderstorm Watch",
  },
  {
    color: "#6DFBFB",
    title: "Severe Weather Statement",
  },
  {
    color: "#C0C0C0",
    title: "Shelter In Place Warning",
  },
  {
    color: "#96F698",
    title: "Short Term Forecast",
  },
  {
    color: "#D7BFD6",
    title: "Small Craft Advisory",
  },
  {
    color: "#CAACC9",
    title: "Small Craft Advisory For Hazardous Seas",
  },
  {
    color: "#C09FBF",
    title: "Small Craft Advisory For Rough Bar",
  },
  {
    color: "#A47EA2",
    title: "Small Craft Advisory For Winds",
  },
  {
    color: "#946F92",
    title: "Small Stream Flood Advisory",
  },
  {
    color: "#C75B5A",
    title: "Snow Squall Warning",
  },
  {
    color: "#E86390",
    title: "Special Marine Warning",
  },
  {
    color: "#FCE4B5",
    title: "Special Weather Statement",
    borderColor: "#B88E3B",
  },
  {
    color: "#DE3B77",
    title: "Storm Surge Warning",
  },
  {
    color: "#AC89A6",
    title: "Storm Surge Watch",
  },
  {
    color: "#9743D4",
    title: "Storm Warning",
  },
  {
    color: "#ED80F7",
    title: "Storm Watch",
  },
  {
    color: "#ED3833",
    title: "Tornado Warning",
  },
  {
    color: "#FEF851",
    title: "Tornado Warning",
  },
  {
    color: "#D4B13E",
    title: "Tropical Depression Local Statement",
  },
  {
    color: "#E4D646",
    title: "Tropical Storm Local Statement",
  },
  {
    color: "#B22724",
    title: "Tropical Storm Warning",
  },
  {
    color: "#F58F8F",
    title: "Tropical Storm Watch",
  },
  {
    color: "#D26A31",
    title: "Tsunami Advisory",
  },
  {
    color: "#EB5F43",
    title: "Tsunami Warning",
  },
  {
    color: "#EB58F9",
    title: "Tsunami Watch",
  },
  {
    color: "#EFE474",
    title: "Typhoon Local Statement",
  },
  {
    color: "#BA3A37",
    title: "Typhoon Warning",
  },
  {
    color: "#ED9E9E",
    title: "Typhoon Watch",
  },
  {
    color: "#696969",
    title: "Volcano Warning",
  },
  {
    color: "#CFA48C",
    title: "Wind Advisory",
    borderColor: "#B07C5F",
  },
  {
    color: "#AFEEEE",
    title: "Wind Chill Advisory",
  },
  {
    color: "#B0C4DE",
    title: "Wind Chill Warning",
  },
  {
    color: "#5F9EA0",
    title: "Wind Chill Watch",
  },
  {
    color: "#EE67B0",
    title: "Winter Storm Warning",
  },
  {
    color: "#4682B4",
    title: "Winter Storm Watch",
  },
  {
    color: "#7B69EE",
    title: "Winter Weather Advisory",
  },
];
export const stateCoordsData = {
  Arizona: {
    north: 37.003875,
    south: 31.332502,
    west: -114.813613,
    east: -109.045223,
  },
  Arkansas: {
    north: 36.499496,
    south: 33.004106,
    west: -94.617919,
    east: -89.686924,
  },
  California: {
    north: 42.009518,
    south: 32.534156,
    west: -124.409591,
    east: -114.131489,
  },
  Colorado: {
    north: 41.003444,
    south: 36.992426,
    west: -109.060062,
    east: -102.041574,
  },
  Connecticut: {
    north: 42.049638,
    south: 40.985171,
    west: -73.727775,
    east: -71.789356,
  },
  Georgia: {
    north: 35.000771,
    south: 30.358035,
    west: -85.605165,
    east: -80.840549,
  },
  Hawaii: {
    north: 22.23317,
    south: 18.917466,
    west: -160.555771,
    east: -154.809379,
  },
  Illinois: {
    north: 42.508302,
    south: 36.970298,
    west: -91.512974,
    east: -87.495211,
  },
  Indiana: {
    north: 41.760592,
    south: 37.776843,
    west: -88.071449,
    east: -84.785111,
  },
  Louisiana: {
    north: 33.019372,
    south: 28.925011,
    west: -94.043147,
    east: -88.817017,
  },
  Minnesota: {
    north: 49.384358,
    south: 43.499356,
    west: -97.239155,
    east: -89.489226,
  },
  Mississippi: {
    north: 34.996052,
    south: 30.173943,
    west: -91.636942,
    east: -88.097888,
  },
  Montana: {
    north: 49.001076,
    south: 44.371038,
    west: -116.049415,
    east: -104.040114,
  },
  "New Mexico": {
    north: 37.000104,
    south: 31.332301,
    west: -109.050044,
    east: -103.001964,
  },
  "North Dakota": {
    north: 49.000687,
    south: 45.935054,
    west: -104.0489,
    east: -96.554835,
  },
  Oklahoma: {
    north: 37.002206,
    south: 33.615765,
    west: -103.002565,
    east: -94.431215,
  },
  Pennsylvania: {
    north: 42.26986,
    south: 39.719998,
    west: -80.51979,
    east: -74.689767,
  },
  Tennessee: {
    north: 36.678118,
    south: 34.983375,
    west: -90.309877,
    east: -81.6469,
  },
  Virginia: {
    north: 39.466012,
    south: 36.540738,
    west: -83.675413,
    east: -75.242266,
  },
  "Puerto Rico": {
    north: 18.515757,
    south: 17.884813,
    west: -67.954119,
    east: -65.22111,
  },
  Delaware: {
    north: 39.838526,
    south: 38.451013,
    west: -75.788658,
    east: -75.048939,
  },
  "West Virginia": {
    north: 40.638801,
    south: 37.202467,
    west: -82.644739,
    east: -77.719029,
  },
  Wisconsin: {
    north: 47.07757,
    south: 42.49192,
    west: -92.888114,
    east: -86.805415,
  },
  Wyoming: {
    north: 45.005904,
    south: 40.994746,
    west: -111.056888,
    east: -104.05216,
  },
  Alabama: {
    north: 35.007712,
    south: 30.221132,
    west: -88.471214,
    east: -84.909052,
  },
  Alaska: {
    north: 179.77847,
    south: 51.219862,
    west: -179.14734,
    east: -129.980058,
  },
  Florida: {
    north: 31.000888,
    south: 24.544701,
    west: -87.634938,
    east: -80.031362,
  },
  Idaho: {
    north: 49.000912,
    south: 41.988057,
    west: -117.214889,
    east: -111.043924,
  },
  Kansas: {
    north: 40.003162,
    south: 36.993083,
    west: -102.051744,
    east: -94.589933,
  },
  Maryland: {
    north: 39.722775,
    south: 37.911717,
    west: -79.487651,
    east: -75.048939,
  },
  "New Jersey": {
    north: 41.357423,
    south: 38.928519,
    west: -75.559446,
    east: -73.893979,
  },
  "North Carolina": {
    north: 36.588117,
    south: 33.844517,
    west: -84.321869,
    east: -75.458659,
  },
  "South Carolina": {
    north: 35.210542,
    south: 32.0346,
    west: -83.352485,
    east: -78.541087,
  },
  Washington: {
    north: 49.002357,
    south: 45.543541,
    west: -124.733174,
    east: -116.915989,
  },
  Vermont: {
    north: 45.016659,
    south: 42.726853,
    west: -73.437429,
    east: -71.464555,
  },
  Utah: {
    north: 42.001567,
    south: 36.997968,
    west: -114.052718,
    east: -109.041723,
  },
  Iowa: {
    north: 43.500945,
    south: 40.378264,
    west: -96.639704,
    east: -90.140613,
  },
  Kentucky: {
    north: 39.147458,
    south: 36.497129,
    west: -89.571509,
    east: -81.968297,
  },
  Maine: {
    north: 47.459686,
    south: 43.059621,
    west: -71.084334,
    east: -66.949895,
  },
  Massachusetts: {
    north: 42.886589,
    south: 41.237964,
    west: -73.508142,
    east: -69.928261,
  },
  Michigan: {
    north: 48.190975,
    south: 41.696089,
    west: -90.418136,
    east: -82.415937,
  },
  Missouri: {
    north: 40.61364,
    south: 35.995812,
    west: -95.774704,
    east: -89.100766,
  },
  Nebraska: {
    north: 43.001378,
    south: 39.999998,
    west: -104.053249,
    east: -95.30829,
  },
  Nevada: {
    north: 42.000252,
    south: 35.002085,
    west: -120.005746,
    east: -114.039882,
  },
  "New Hampshire": {
    north: 45.305293,
    south: 42.69699,
    west: -72.556214,
    east: -70.703936,
  },
  "New York": {
    north: 45.01585,
    south: 40.496103,
    west: -79.762152,
    east: -71.856214,
  },
  Ohio: {
    north: 41.977523,
    south: 38.404338,
    west: -84.820157,
    east: -80.518693,
  },
  Oregon: {
    north: 46.269531,
    south: 41.992671,
    west: -124.552441,
    east: -116.463504,
  },
  "Rhode Island": {
    north: 42.018798,
    south: 41.146339,
    west: -71.862772,
    east: -71.12057,
  },
  "South Dakota": {
    north: 45.94545,
    south: 42.479846,
    west: -104.057698,
    east: -96.436589,
  },
  Texas: {
    north: 36.500397,
    south: 25.856459,
    west: -106.627808,
    east: -93.527644,
  },
};
export const statesArrayData = [
  { name: "Arizona", code: "AZ" },
  { name: "Arkansas", code: "AR" },
  { name: "Colorado", code: "CO" },
  { name: "Idaho", code: "ID" },
  { name: "Illinois", code: "IL" },
  { name: "Iowa", code: "IA" },
  { name: "Kansas", code: "KS" },
  { name: "Minnesota", code: "MN" },
  { name: "Missouri", code: "MO" },
  { name: "Nebraska", code: "NE" },
  { name: "New Mexico", code: "NM" },
  { name: "Oklahoma", code: "OK" },
  { name: "South Dakota", code: "SD" },
  { name: "Texas", code: "TX" },
  { name: "Utah", code: "UT" },
  { name: "Wisconsin", code: "WI" },
  { name: "Wyoming", code: "WY" },
  { name: "Alabama", code: "AL" },
  { name: "Alaska", code: "AK" },
  { name: "California", code: "CA" },
  { name: "Connecticut", code: "CT" },
  { name: "Delaware", code: "DE" },
  { name: "Florida", code: "FL" },
  { name: "Georgia", code: "GA" },
  { name: "Hawaii", code: "HI" },
  { name: "Indiana", code: "IN" },
  { name: "Kentucky", code: "KY" },
  { name: "Louisiana", code: "LA" },
  { name: "Maine", code: "ME" },
  { name: "Maryland", code: "MD" },
  { name: "Massachusetts", code: "MA" },
  { name: "Michigan", code: "MI" },
  { name: "Mississippi", code: "MS" },
  { name: "Montana", code: "MT" },
  { name: "Nevada", code: "NV" },
  { name: "New Hampshire", code: "NH" },
  { name: "New Jersey", code: "NJ" },
  { name: "New York", code: "NY" },
  { name: "North Carolina", code: "NC" },
  { name: "North Dakota", code: "ND" },
  { name: "Ohio", code: "OH" },
  { name: "Oregon", code: "OR" },
  { name: "Pennsylvania", code: "PA" },
  { name: "Rhode Island", code: "RI" },
  { name: "South Carolina", code: "SC" },
  { name: "Tennessee", code: "TN" },
  { name: "Vermont", code: "VT" },
  { name: "Virginia", code: "VA" },
  { name: "Washington", code: "WA" },
  { name: "West Virginia", code: "WV" },
  { name: "Puerto Rico", code: "PR" },
];
